import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { ImageComponent } from '@teamfoster/sdk/image';

import { SwiperContainer } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';
import { Header } from '../../models/header.model';
import { IconComponent } from '@teamfoster/sdk/icon';
import { LinkComponent } from '@teamfoster/sdk/button';

@Component({
  selector: 'app-header-gallery',
  imports: [ImageComponent, IconComponent, LinkComponent, IconComponent],
  templateUrl: './header-gallery.component.html',
  styleUrl: './header-gallery.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderGalleryComponent implements AfterViewInit, OnDestroy {
  header = input.required<Header>();

  swiperIndex$ = signal(0);
  @ViewChild('swiper') swiperEl?: ElementRef<SwiperContainer>;
  cd = inject(ChangeDetectorRef);

  sliderImages = computed(() => {
    const images = this.header().images || [];
    return [...images, ...images, ...images];
  });

  ngAfterViewInit(): void {
    this.initSwiper();
  }

  initSwiper() {
    const that = this;

    const params: SwiperOptions = {
      loop: true,
      autoplay: false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      navigation: false,
      centeredSlides: true,

      //slidesOffsetBefore: -50,
      mousewheel: {
        forceToAxis: true,
      },
      injectStyles: [
        `
        :host .swiper {
          overflow:inherit;
        }
        `,
      ],
      breakpoints: {
        0: {
          spaceBetween: 5,
          //centeredSlides: true,
        },
        768: {
          spaceBetween: 10,
          //centeredSlides: false,
        },
      },
      on: {
        realIndexChange: function (i) {
          that.swiperIndex$.set(i.realIndex);
          that.cd.detectChanges();
        },
        resize: function () {
          that.cd.detectChanges();
        },
      },
    };

    if (this.swiperEl?.nativeElement?.initialize) {
      Object.assign(this.swiperEl.nativeElement, params);
      this.swiperEl.nativeElement.initialize();
      this.cd.detectChanges();
    }
  }

  slideNext() {
    this.swiper?.slideNext();
  }
  slidePrev() {
    this.swiper?.slidePrev();
  }

  get swiper() {
    return this.swiperEl?.nativeElement.swiper;
  }
  get allowSlideNext() {
    return this.swiper?.allowSlideNext;
  }
  get allowSlidePrev() {
    return this.swiper?.allowSlidePrev;
  }
  get isBeginning() {
    return this.swiper?.isBeginning;
  }
  get isEnd() {
    return (this.swiper?.activeIndex || 0) === (this.header().images?.length || 0) - 1;
  }

  ngOnDestroy(): void {
    // CRITICAL: Destroy Swiper instance to prevent memory leaks
    this.swiper?.destroy(true, true);
  }

  preventBack(event: any) {
    if (event.wheelDeltaX !== 0) {
      event.preventDefault();
    }
  }
}
